import { defineStore } from 'pinia'
import { ref, computed, reactive } from "vue";




export const useCampaignsStore = defineStore('campaigns', () => {
 
  const tablePagination = reactive({
      first: 20,
      page: 1,
  })

  const gridPagination = reactive({
    first: 20,
    page: 1,
})

  const filters = ref({
    campaign: {
      value: null,
      modifiers: {
        matchType: 'contains'
      },
      title: 'Campaign',
      type: 'input'
    },
    verticals: {
      value: [],
      optionLabelKey: 'name',
      singularTitle: 'Vertical',
      title: 'Verticals',
    },
    countries: {
      value: null,
      title: 'Countries',
      singularTitle: 'Country',
      type: 'select',
      multiple: false,
      optionLabelKey: 'label',
      shortLabelKey: 'code',
      trackByKey: 'code'
    },
    devices: {
      value: null,
      modifiers: {
        matchType: 'exact'
      }
    },
    allowed: {
      value: null,
      optionLabelKey: 'name',
      modifiers: {
        exclude: false
      }
    },
    status: {
      value: null,
      modifiers: {
        matchType: 'exact'
      }
    },
    offerType: {
      value: null,
      modifiers: {
        matchType: 'exact'
      }
    },
    campaignBrowser: {
      value: null,
      type: 'select',
      trackByKey: 'name'
    },
    campaignOS: {
      value: null,
      type: 'select',
      trackByKey: 'name'
    },
    payoutType: {
      value: null,
      modifiers: {
        matchType: 'exact'
      }
    }
  })

  const updateTablePagination = (input) => {
    tablePagination.first = input.first
    tablePagination.page = input.page
  }

  const updateGridPagination = (input) => {
    gridPagination.first = input.first
    gridPagination.page = input.page
  }

  return { 
    filters, 
    tablePagination, 
    gridPagination, 
    updateTablePagination, 
    updateGridPagination
  }

})